export default "__VITE_ASSET__Dltxr5X___"